import React, { Component } from "react";

//import Header from "../component/Header";
import HeaderAudioBook from "../component/HeaderAudioBook";
import BottomNavAudioBook from "../component/BottomNavAudioBook";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');


//var DEBUG2=true;
var DEBUG2=false;


class AudioBook extends Component {

    constructor(props) {
		super(props);
		this.state = { headerTitle: "더책" };
        this.state = { ...this.state, loading: true, open: false, bi: [], contract: false, bookid:props.match.params.bookid };

		this.doOpenAlert = this.doOpenAlert.bind(this);
		this.doCloseAlert = this.doCloseAlert.bind(this);
		this.doPlayNow = this.doPlayNow.bind(this);

		//alert(JSON.stringify(props));

		fetch('/api/AB/BOOKInfo?bookid=' + props.match.params.bookid)
			.then(response => response.json())
			.then(data => {
				//this.setState({ forecasts: data, loading: false });
                if(DEBUG2) console.log(JSON.stringify(data));
				//alert(data.totalcount);
				//this.state.totalcount = data.totalcount;
				//this.state.loading = true;
				//alert(this.state.totalcount);

				this.setState({ ...this.state, bi: data.bi, contract : data.iscontract, loading: false });

				this.dohistorymark();
			});
	}

	domarkbook() {
		//alert(this.state.bi.id);

		let struserid = cookie.load("general_userid");
		let struserdbid = cookie.load("general_userdbid");

		fetch('/api/AB/BookMark', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				userdbid: struserdbid,
				bookid: this.state.bi.id,
				marktype: 5,
				ispreview:0
				})
			})
			.then(response => response.json())
			.then(data => {
				//alert('대출하였습니다.');
				this.doOpenAlert();
			});
	}

	dohistorymark() {
		//alert(this.state.bi.id);

		let struserid = cookie.load("general_userid");
		let struserdbid = cookie.load("general_userdbid");

		fetch('/api/AB/BookMark', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				userdbid: struserdbid,
				bookid: this.state.bi.id,
				marktype: 1,
				ispreview:0
				})
			})
			.then(response => response.json())
			.then(data => {
				//alert('대출하였습니다.');
			});
	}

	doOpenAlert() {
		this.setState({ ...this.state, open: true, contract:false });
		//this.state = { ...this.state, open: true };
	}

	doCloseAlert() {
		this.setState({ ...this.state, open: false, contract: false });
		//this.state = { ...this.state, open: false };
	}

	doPlayNow() {

		var link = document.getElementById('m_btnplay');
		link.click();

		this.doCloseAlert();

		
	}

	dologin() {
		window.location = "/signin";
	}

	dorender() {

		let struserid = cookie.load("general_userid");
		let struserdbid = cookie.load("general_userdbid");
		let iscontract = this.state.contract;
		let book = this.state.bi;
		let bookreview = book.tblBookDetail.review;
		if (bookreview === undefined || bookreview === null || bookreview.length === 0) {
			//bookreview = "현재 리뷰가 없습니다.";
	        bookreview = "현재 소개글이 없는 도서입니다.";
		}

		let booktoc = book.tblBookDetail.toc;
		if (booktoc === undefined || booktoc === null || booktoc.length === 0) {
	        booktoc = "현재 목차가 없는 도서입니다.";
		}

		var bispreview = false;
		for (const itm of book.tblSubcontent) {
			if(DEBUG2) console.log('preview: ' + itm.ispreview);
			if (itm.ispreview === 1) {
				bispreview = true;
				break;
			}
		}

        this.logPageView();

        let btnplay = null;
        let btnMark = "";

        
        let is_pc= window.navigator.userAgent.indexOf("Windows")> -1;
        //is_pc= is_pc | window.navigator.userAgent.indexOf("Mac")> -1;


        if (struserid != null && struserid.length > 0) {

            let orgid = cookie.load("orgid");
            if (iscontract && orgid!=20) {
                if(is_pc) {
                    btnplay = <a className="tag tag-audiobook2" id="m_btnplay" href={`javascript:makeAUDIO("${this.state.bookid}&${struserdbid}&0")`} >오디오북 듣기</a>
                } else {
                    btnplay = <a className="tag tag-audiobook2" id="m_btnplay" href={`mcbab://bookid/${this.state.bookid}&${struserdbid}&0`} >오디오북 듣기</a>
                }
            }
            else {
                if(is_pc) {
                    btnplay = <a className="tag tag-audiobook" id="m_btnplay" href={`javascript:makeAUDIO("${this.state.bookid}&${struserdbid}&1")`} >미리 듣기</a>
                } else {
                    btnplay = <a className="tag tag-audiobook" id="m_btnplay" href={`mcbab://bookid/${this.state.bookid}&${struserdbid}&1`} >미리듣기</a>
                }
                btnplay = <span className="tag tag-audiobook2">미 계약 도서 입니다.</span>
            }
			//btnMark = <a className="tag tag-ebook" href='#' onClick={() => this.domarkbook()}>대출하기<br /></a>
		}
		else {
			if (bispreview === true) {
                if(is_pc) {
                    btnplay = <a className="tag tag-audiobook" id="m_btnplay" href={`javascript:makeAUDIO("${this.state.bookid}&${struserdbid}&1")`} >미리 듣기</a>
                } else {
                    btnplay = <a className="tag tag-audiobook" id="m_btnplay" href={`mcbab://bookid/${this.state.bookid}&0&1`} >미리듣기</a>
                //btnplay = <a className="tag tag-audiobook2" onClick={() => this.dologin()}>로그온이 필요합니다.</a>
                }
			}
			else {
                //btnplay = <a className="tag tag-audiobook2" onClick={() => this.dologin()}>로그온이 필요합니다.</a>
			}
		}

		var st_content = "";
		if (book.serviceType === 50) {
			st_content = <React.Fragment><span className='tag tag-thebook-kind'>더책</span> <span className='tag tag-audiobook-kind'>오디오북</span></React.Fragment>
		}
		else if (book.serviceType === 20) {
			st_content = <span className="tag tag-thebook-kind">더책</span>
		}
		else if (book.serviceType === 40) {
		    st_content = <span className="tag tag-audiobook-kind">오디오북</span>
		}

		return (
			<React.Fragment>
				<Dialog open={this.state.open} onClose={this.doCloseAlert}>
					<div className="dialog-body">
						<p>대출하였습니다.</p>
					</div>
					<div className="dialog-footer">
						<button onClick={this.doCloseAlert} color="primary" autoFocus className="btn btn-primary btn-sm">
							닫기
						</button>
						<br/>
						<button onClick={this.doPlayNow} color="primary" autoFocus className="btn btn-primary btn-sm">
							바로듣기
						</button>
					</div>
				</Dialog>
				<div className="bookDetail-header">
					<div className="bookList-thumbnail">
						<div className="thumbnail">
							<img className="thumbnail-image" src={`/api/AB/GetCoverImage?thumb=8&imgid=${this.state.bookid}`} alt={book.subject} />
						</div>
					</div>
					<div className="bookDetail-info">
						<h3 id="book1_subject" className="bookDetail-title">{book.subject}</h3>
						<h4 id="book1_authorname" className="bookDetail-author">작가: {book.authorName}</h4>
						<h4 id="book1_publisher" className="bookDetail-author">출판사: {book.publisher.publisherName}</h4>
						<div className="bookList-tag">
							{st_content}
						</div>
						<div className="bookList-tag">
							{btnplay}{btnMark}
						</div>
					</div>
				</div>
				<div className="bookDetail-body">
					<div className="bookDetail-section">
						<h3 className="bookDetail-section-title">소개</h3>
						<p id="book1_brief" className="bookDetail-description" dangerouslySetInnerHTML={{__html:bookreview}}></p>
					</div>
					<div className="bookDetail-section">
						<h3 className="bookDetail-section-title">목차</h3>
						<p id="book1_toc" className="bookDetail-description" dangerouslySetInnerHTML={{ __html: booktoc }}></p>
					</div>
					<div className="bookDetail-section">
						<h3 className="bookDetail-section-title">추천글</h3>
						<p id="book1_recommend" className="bookDetail-description" dangerouslySetInnerHTML={{ __html: book.tblBookDetail.rReview }}></p>
					</div>
				</div>
			</React.Fragment>
		);
    }

    logPageView() {
	ReactGA.set({ page: window.location.pathname });
	ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {

		let contents = this.state.loading === true
            ? <p className="section-description">Loading...</p>
        : this.dorender(); 

		return (
            <React.Fragment >
				<HeaderAudioBook headerTitle={this.state.headerTitle} />
                <div className="bookDetail">
					{contents}
				</div>
				<BottomNavAudioBook />
			</React.Fragment>
		);
	}
}

export default AudioBook;
